module.exports = __webpack_public_path__ + "static/media/wellnite-auth-hero_200.9fc2dad3.webp";